module.exports = __webpack_public_path__ + "sa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/sa.svg
// module id = 1043
// module chunks = 0